import React, { useEffect, useRef, useState } from "react";

import Image from "../../components/image";
import { useTheme } from "../../context/ThemeContext";
import { useProgramFees } from "../../hooks/useProgramFees";
import { useProgramTitles } from "../../hooks/useProgramTitles";
import { shortcodePreProcessor } from "../../utils/formatContent";
import { renderCurrencyDateImage } from "../../utils/formatContent";
import CtaButton from "./buttons/ctaButton";
import ShareBtn from "./shareBtn";

const EnquireCard = ({
  applyNow,
  enquireNow,
  isMobile = false,
  cardStyle = "",
  cardDefaultWidth = "sm:w-[355px]",
  enquireCardDetails = {},
  applyCTALabel = "Student<br />Application",
  enquireCTALabel = "Educator<br />Enquiry",
  isGVI = true,
  descClass = "mb-4 text-xl font-normal text-left text-white !leading-6",
  programPrice = ""
}) => {
  const { localeLanguage, currentSiteMeta, currentBrand } = useTheme();
  const [shareUrl, setShareUrl] = useState();

  const dateStrFormat = "";

  const {
    cardTitle,
    enquireCardImg,
    cardDesc,
    cardBookDesc,
    shareButton = true
  } = enquireCardDetails;

  const shareBtnRef = useRef();

  useEffect(() => {
    // eslint-disable-next-line no-restricted-globals
    setShareUrl(encodeURI(location?.href ?? "#"));
  }, []);

  const programFees = useProgramFees() || [];
  const programSubtitles = useProgramTitles() || "";

  const datesCostSubtitle = shortcodePreProcessor({
    programFees,
    currentSiteMeta,
    description: programSubtitles?.datesCostsSubtitle
  });

  const showPricingExtra = false;

  return (
    <div
      className={`max-w-sm w-full relative ${
        isMobile ? "block sm:hidden" : ""
      } ${cardDefaultWidth} ${cardStyle}`}
    >
      <div className="relative transition duration-500 sm:shadow-lg hover:shadow-xl sm:border-gray-testimonial rounded-xs sm:rounded-xs border-0 sm:border-[0.5px]">
        <div className="relative flex items-center w-full overflow-hidden h-44 rounded-xs sm:rounded-br-none sm:rounded-bl-none">
          {enquireCardImg && (
            <Image
              imageAlt=""
              image={""}
              imageClass="object-cover object-center w-full rounded-xs sm:rounded-br-none sm:rounded-bl-none"
              sourceUrl={enquireCardImg}
            />
          )}
          {cardTitle && (
            <div
              className="px-8 h1 font-normal text-left !text-white font-body   leading-10"
              dangerouslySetInnerHTML={{ __html: cardTitle }}
            />
          )}
        </div>

        {(cardBookDesc || showPricingExtra) && (
          <div className={`px-1 sm:px-6 py-4 bg-green-dark `}>
            {showPricingExtra ? (
              <div className="w-full bg-gray-lighten  rounded-full flex py-2 items-center justify-center gap-2 my-5">
                <Image
                  imageAlt={""}
                  image={""}
                  imageClass="inline-block w-5"
                  sourceUrl={renderCurrencyDateImage({
                    currentSiteMeta,
                    currentBrand
                  })}
                />
                <div
                  className="desc font-body text-xs text-white"
                  dangerouslySetInnerHTML={{ __html: datesCostSubtitle }}
                />
              </div>
            ) : (
              <>
                {isGVI && (
                  <div className="flex items-center gap-x-6 space-between py-4">
                    {cardBookDesc && (
                      <div className="flex items-center justify-center w-1/2">
                        <div
                          className="text-xs text-left font-normal text-white"
                          dangerouslySetInnerHTML={{
                            __html: `${cardBookDesc}`
                          }}
                        />
                      </div>
                    )}
                    {shareButton === true ? (
                      <>
                        <CtaButton
                          preset={"septenary"}
                          ctaLabel={"Share"}
                          customIcon={
                            <ShareBtn
                              url={shareUrl}
                              ref={shareBtnRef}
                              iconClass="w-3 fill-white"
                              iconActiveClass="xxs:w-4 xxs:h-4 fill-gray-lighter"
                              activeIconContainerClass="xxs:-top-3 xxs:left-16"
                            />
                          }
                          type="custom"
                          showAsButton={true}
                          onClick={() => shareBtnRef.current.handleClick()}
                          labelClass="text-base font-normal order-1 sm:pt-1"
                          extraButtonStyle="gap-x-2 px-6 xxxs:rounded-full  sm:min-w-36"
                        />
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                )}
              </>
            )}
          </div>
        )}

        <div
          className={`flex rounded-full sm:rounded-t-none sm:rounded-b-xs bg-yellow-standard  ${
            (enquireNow || applyNow) && "sm:h-16"
          }`}
        >
          {enquireNow && (
            <>
              <CtaButton
                ctaLabel={enquireCTALabel}
                preset={"nonary"}
                labelClass="text-sm text-center font-bold uppercase"
                extraButtonStyle={`w-full`}
                showAsButton={false}
                showArrowIcon={false}
                to={enquireNow}
              />
            </>
          )}

          {applyNow && (
            <CtaButton
              ctaLabel={applyCTALabel}
              preset={"denary"}
              labelClass="text-sm text-center"
              extraButtonStyle={`w-full`}
              showAsButton={false}
              showArrowIcon={false}
              to={applyNow}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default EnquireCard;
